// extracted by mini-css-extract-plugin
export default {"purchaseReview":"affiliateContext_purchaseReview__G-siP","addressBlock":"affiliateContext_addressBlock__cL6zP","idBlock":"affiliateContext_idBlock__O267x"};